import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Table } from "react-bootstrap";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import "./Collage_intern.css";
import View_applications from "../../../../common_components/common_offcanvas/view_applications/View_applications";

const Collage_intern = () => {
  const [showCanvas, setShowCanvas] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const courseRef = useRef(null);
  const handleStatusSelect = (status) => {
    console.log(status); // apply status filter/update here
    setOpenStatus(false);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const applications = [
    {
      name: "Garde Manger",
      program: "Garde Manger",
      status: "Under Review",
      date: "12 Oct 2025",
    },
    {
      name: "Sous Chef",
      program: "Garde Manger",
      status: "Accepted",
      date: "24 Oct 2025",
    },
    {
      name: "Saucier (Sauce Chef)",
      program: "Garde Manger",
      status: "Refused",
      date: "01 Nov 2025",
    },
    {
      name: "Student Advisor",
      program: "Garde Manger",
      status: "Payment Due",
      date: "06 Nov 2025",
    },

    {
      name: "Garde Manger",
      program: "Garde Manger",
      status: "Under Review",
      date: "12 Oct 2025",
    },
    {
      name: "Sous Chef",
      program: "Garde Manger",
      status: "Accepted",
      date: "24 Oct 2025",
    },
    {
      name: "Saucier (Sauce Chef)",
      program: "Garde Manger",
      status: "Refused",
      date: "01 Nov 2025",
    },
    {
      name: "Student Advisor",
      program: "Garde Manger",
      status: "Payment Due",
      date: "06 Nov 2025",
    },

    {
      name: "Garde Manger",
      program: "Garde Manger",
      status: "Under Review",
      date: "12 Oct 2025",
    },
    {
      name: "Sous Chef",
      program: "Garde Manger",
      status: "Accepted",
      date: "24 Oct 2025",
    },
    {
      name: "Saucier (Sauce Chef)",
      program: "Garde Manger",
      status: "Refused",
      date: "01 Nov 2025",
    },
    {
      name: "Student Advisor",
      program: "Garde Manger",
      status: "Payment Due",
      date: "06 Nov 2025",
    },
  ];

  const statusClass = {
    "Under Review": "under-review",
    Accepted: "accepted",
    Refused: "refused",
    "Payment Due": "payment-due",
  };

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          {/* Search */}
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Program"
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>

          {/* SECOND DROPDOWN */}
          <div className="dropdown_wrapper" ref={courseRef}>
            <button
              className="dark_btn"
              onClick={() => setOpenStatus(!openStatus)}
            >
              Status
              <div className="aap_icon_holder">
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`dropdown_icon ${openStatus ? "rotate" : ""}`}
                />
              </div>
            </button>

            {openStatus && (
              <div className="custom_dropdown">
                <button
                  className="dropdown_item"
                  onClick={() => handleStatusSelect("Under Review")}
                >
                  Under Review
                </button>

                <button
                  className="dropdown_item"
                  onClick={() => handleStatusSelect("Accepted")}
                >
                  Accepted
                </button>

                <button
                  className="dropdown_item"
                  onClick={() => handleStatusSelect("Refused")}
                >
                  Refused
                </button>

                <button
                  className="dropdown_item"
                  onClick={() => handleStatusSelect("Payment Due")}
                >
                  Payment Due
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Active Applications</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Program </th>
                  <th>Status </th>
                  <th>Last Update</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {applications.map((app, index) => (
                  <tr key={index}>
                    <td>{app.name}</td>
                    <td>{app.program}</td>

                    <td>
                      <span
                        className={`status-badge ${statusClass[app.status]}`}
                      >
                        {app.status}
                      </span>
                    </td>

                    <td>{app.date}</td>

                    <td>
                      <div className="action_btn_holder">
                        <Button
                          className="eye_btn action_btn_icon"
                          onClick={() => setShowCanvas(true)}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </section>
      <View_applications
        show={showCanvas}
        handleClose={() => setShowCanvas(false)}
      />
    </>
  );
};

export default Collage_intern;
